module.exports = __webpack_public_path__ + "img/icon-arrows-down.d33a9aed.svg";